module.exports = __webpack_public_path__ + "static/cashew_nuts_dieu_4-3ee5dad6cd20dfcee2d1bfc98c9f8505.jpg";